import { noop } from 'lodash';
import MutationManager from '../../../../../lib/MutationManager';

/**
 * The variation mutations observer, We called with observe true config it will :
 * 1) Register and sync the current variation under mutation cache.
 * 2) Registers any mutations triggered via updateVariation callback
 *
 * This allows consumers afterwards to access mutated data when needed.
 */
export const useVariationMutationObserver = (variation, observe) => {
    const variationId = variation.id;
    if (!observe) {
        return [noop];
    }

    MutationManager.syncVariation(variation);

    const updateVariation = ({ root, layer }) => {
        root && MutationManager.observeMutation(variationId, root);
        layer && MutationManager.observeMutation(variationId, layer);
    };

    return [updateVariation];
};
